/**
 * 应用配置。生产环境可在 .env.production 中设置 REACT_APP_API_BASE_URL
 */
const config = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000',
};

export default config;
